<template>
  <div class="pet-store">
    <main class="main-content">
      <section class="merchant-recruitment">
        <h1>面向全国招募商家</h1>
        <p>优质平台，值得您的加入！</p>

        <h2>入驻优势</h2>
        <ul>
          <li>平台专注宠物活体交易，高效、专业、精准。</li>
          <li>平台覆盖全国用户，让您足不出户全国开单。</li>
          <li>
            在线发布宠物，无中间环节，买卖双方直接对接，交易过程简单高效。
          </li>
          <li>平台开放招募期间，入驻商家均享有每日首次发布免费特权。</li>
        </ul>

        <h2>入驻标准</h2>
        <ul>
          <li>
            遵守平台商家规范，接受平台质保要求，为消费者提供至少10天健康担保。
          </li>
          <li>缴纳2000元人民币担保金作为信誉担保。</li>
          <li>接受安排专人实地考察。</li>
          <li>接受平台不定期对话回访，提供宠物免疫、驱虫等健康证明。</li>
        </ul>

        <h2>入驻流程</h2>
        <ol>
          <li>下载买只宠物APP，注册登录，进入我的页面进行商家认证。</li>
          <li>在线实名认证并缴费后即可开通店铺，发布和交易宠物。</li>
          <li>
            如果您同时提交营业执照，平台审核通过后，您将获得认证商家资质，身份更高一级。
          </li>
        </ol>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "MerchantRecruitment",
};
</script>

<style scoped>
.pet-store {
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  width: 60%;
  max-width: 1200px;
  padding: 20px;
  background-color: #fff;
}

.merchant-recruitment {
  margin-bottom: 20px;
}

.merchant-recruitment h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.merchant-recruitment p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.merchant-recruitment h2 {
  font-size: 20px;
  margin: 20px 0 10px;
}

.merchant-recruitment ul,
.merchant-recruitment ol {
  margin: 0;
  padding-left: 20px;
  list-style-type: none; /* 隐藏项目符号 */
}

.merchant-recruitment li {
  margin-bottom: 5px;
}
</style>
